import script from "./VAssetName.vue?vue&type=script&lang=ts&setup=true"
export * from "./VAssetName.vue?vue&type=script&lang=ts&setup=true"

import "./VAssetName.vue?vue&type=style&index=0&id=2989a597&lang=sass"

const __exports__ = script;

export default __exports__